module.exports = __webpack_public_path__ + "static/media/download.b09d516b.svg";